import PropTypes from 'prop-types';
import React from 'react';

class RetailerBrandWeightingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { total: 0, selectedRetailer: "" };
  }

  componentDidMount() {
    if (this.props.retailer_brand_weight.retailer_brand_weights) {
      let totalValue = 0;
      this.props.retailer_brand_weight.retailer_brand_weights.forEach((r) => {
        const rValue = parseFloat(r.weight) || 0;
        totalValue += rValue;
      });
      this.setState({ total: totalValue, selectedRetailer: parseInt(this.props.retailer_brand_weight.retailer_brand_weights[0].retailer_id) });
    } else {
      this.setState({selectedRetailer: this.props.retailers[0].id})
    }

  }

  handleChange = () =>  {
    let inputs = document.querySelectorAll('.weight-percent');
    let totalValue = 0;
    inputs.forEach((input) => {
      const userValue = parseFloat(input.value) || 0;
      totalValue += userValue;
    });

    this.setState({ total: totalValue });
  }

  handleSelectChange = (event) =>  {
    this.setState({ selectedRetailer: event.target.value });
  }

  findPreviousValue = (weights, brand) => {
   const filtered = weights.filter((weight)=> ( weight.brand_id == brand.id && weight.retailer_id == this.state.selectedRetailer))

    if (filtered.length >0) {
      return filtered[0].weight
    }
  }

  render() {
    return (
      <div
        id="RetailerBrandWeightForm"
        className="shadow overflow-hidden px-4 py-5 bg-white sm:p-6 sm:rounded-md"
      >
        <div>
          {this.props.retailer_brand_weight.errors &&
            this.props.retailer_brand_weight.errors.base.length > 0 && (
              <div id="error_explanation">
                <p>
                  {' '}
                  {this.props.retailer_brand_weight.errors.base.length > 1
                    ? `${this.props.retailer_brand_weight.errors.base.length} errors`
                    : '1 error'}{' '}
                  prohibited the weights from being saved:
                </p>
                <ul>
                  {this.props.retailer_brand_weight.errors.base.map((error) => (
                    <li>{error}</li>
                  ))}
                </ul>
              </div>
            )}
        </div>
        <div className="grid grid-cols-3">
          <div className="col-span-1 font-medium text-gray-700">Retailer</div>
          <div className="col-span-1 col-start-2 font-medium text-gray-700">
            Brand
          </div>
          <div className="col-span-1 col-start-3 font-medium text-gray-700">
            Weight(%)
          </div>
        </div>
          <div className="grid grid-cols-3 py-3" >
            <div className="col-span-1">
              <select id={"retailer_select"} onChange={this.handleSelectChange} value={this.state.selectedRetailer}>
                {this.props.retailers.map((retailer)=>(<option key={retailer.name} value={retailer.id} >{retailer.name}</option>))}
              </select>
            </div>
            {this.props.brands.map((brand) => (
              <React.Fragment key={brand.id}>
                <div className="col-start-2">
                  <label className="block  text-gray-700">{brand.name}</label>
                  <input
                    type="hidden"
                    value={brand.id}
                    name="retailer_brand_weights[retailer_brand_weights][][brand_id]"
                    className="measure w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
                  ></input>
                </div>
                <div className="col-start-3">
                  <input
                    type="number"
                    readOnly={false}
                    defaultValue={
                      this.props.retailer_brand_weight.retailer_brand_weights
                        ? this.findPreviousValue(this.props.retailer_brand_weight.retailer_brand_weights, brand) : 0
                    }
                    onChange={this.handleChange}
                    id={`${brand.name}_weight`}
                    name="retailer_brand_weights[retailer_brand_weights][][weight]"
                    className="weight-percent w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
                  ></input>
                </div>
                <input
                  type="hidden"
                  name="retailer_brand_weights[retailer_brand_weights][][retailer_id]"
                  value={this.state.selectedRetailer}
                />
                <input
                  type="hidden"
                  id={`${brand.name}_retailer_brand_weights__client_id`}
                  name="retailer_brand_weights[retailer_brand_weights][][client_id]"
                  value={this.props.client}
                />
              </React.Fragment>
            ))}
          </div>
          <div className="grid grid-cols-3">
          <div className="col-span-1 col-start-2 font-medium text-gray-700">Total</div>
          <div
            id="totalCounter"
            className={
              this.state.total == 100
                ? 'text-green-600 col-span-1 col-start-3'
                : 'text-red-600 col-span-1 col-start-3'
            }
          >
            {this.state.total} / 100%
          </div>
        </div>

        <div className="actions">
          <input type="submit" value="Submit" />
          <a class="secondary-btn ml-2" href="/weights_targets">Cancel</a>
        </div>
      </div>
    );
  }
}

RetailerBrandWeightingForm.propTypes = {
  client: PropTypes.number,
  retailers: PropTypes.array,
};

export default RetailerBrandWeightingForm;
